import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Profile from './views/Profile.vue'
import Glasses from './views/Glasses.vue'
import { ColorSets, ModuleOption, SelectionType, TileType } from '@/data/enums'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/profile',
      component: Profile,
      children: [
        {
          name: 'profile',
          path: '',
          component: () => import(/* webpackChunkName: "profile" */ './components/CustomerIdentity.vue'),
          props: {
            currentStep: 0,
            prev: '/',
            next: '/profile/screens',
            subtitle: '&nbsp;',
            title: 'page_profile_title',
            type: SelectionType.Gender
          }
        }, {
          path: 'screens',
          component: () => import(/* webpackChunkName: "profile" */ './components/ProfileStep.vue'),
          props: {
            currentStep: 1,
            prev: '/profile',
            next: 'transport',
            tileType: TileType.Time,
            subtitle: 'page_vision_subtitle',
            title: 'page_profile_title',
            type: SelectionType.Screen
          }
        }, {
          path: 'transport',
          component: () => import(/* webpackChunkName: "profile" */ './components/ProfileStep.vue'),
          props: {
            currentStep: 2,
            prev: '/profile/screens',
            next: '/profile/activities',
            subtitle: 'page_vision_subtitle',
            tileType: TileType.Time,
            title: 'page_profile_title',
            type: SelectionType.Transport
          }
        }, {
          path: 'activities',
          component: () => import(/* webpackChunkName: "profile" */ './components/ProfileStep.vue'),
          props: {
            currentStep: 3,
            prev: '/profile/transport',
            next: '/profile/sport',
            subtitle: 'page_activity_subtitle',
            title: 'page_profile_title',
            type: SelectionType.Activity
          }
        }, {
          path: 'sport',
          component: () => import(/* webpackChunkName: "profile" */ './components/ProfileStep.vue'),
          props: {
            currentStep: 4,
            prev: '/profile/activities',
            next: '/profile/advice',
            subtitle: 'page_sport_subtitle',
            title: 'page_profile_title',
            type: SelectionType.Sport
          }
        }, {
          path: 'advice',
          component: () => import(/* webpackChunkName: "glasses" */ './components/ProfileAdvice.vue')
        }, {
          path: 'glasses',
          component: () => import(/* webpackChunkName: "profile" */ './components/ProfileStep.vue'),
          props: {
            currentStep: 5,
            prev: '/profile/advice',
            next: '/glasses',
            subtitle: 'page_glasses_subtitle',
            tileType: TileType.Smiley,
            title: 'page_current_title',
            type: SelectionType.Glasses
          }
        },
        { path: '*', redirect: '/profile' }
      ]
    },
    {
      path: '/glasses',
      component: Glasses,
      children: [
        {
          name: 'selection',
          path: '',
          component: () => import(/* webpackChunkName: "glasses" */ './components/GlassSelection.vue')
        }, {
          name: 'dneye',
          path: 'dneye',
          component: () => import(/* webpackChunkName: "dneye" */ './components/modules/DneyeModule.vue'),
          meta: { requiresGlasses: true }
        }, {
          name: 'impressionist',
          path: 'impressionist',
          component:
            () => import(/* webpackChunkName: "impressionist" */ './components/modules/ImpressionistModule.vue'),
          meta: { requiresGlasses: true }
        }, {
          name: 'glass',
          path: 'glass',
          component: () => import(/* webpackChunkName: "glasses" */ './components/GlassType.vue'),
          meta: { requiresGlasses: true }
        }, {
          name: 'suncoating',
          path: 'suncoating',
          component: () => import(/* webpackChunkName: "glasses" */ './components/modules/SunCoatingModule.vue'),
          meta: { requiresGlasses: true }
        }, {
          name: 'coating',
          path: 'coating',
          component: () => import(/* webpackChunkName: "glasses" */ './components/modules/CoatingModule.vue'),
          meta: { requiresGlasses: true }
        }, {
          name: 'lifestyle',
          path: 'lifestyle',
          component: () => import(/* webpackChunkName: "glasses" */ './components/modules/LifestyleModule.vue'),
          meta: { requiresGlasses: true },
          props: {
            optionId: ModuleOption.Lifestyle
          }
        }, {
          name: 'ergo',
          path: 'ergo',
          component: () => import(/* webpackChunkName: "glasses" */ './components/modules/ErgoDesignModule.vue'),
          meta: { requiresGlasses: true },
          props: {
            optionId: ModuleOption.Ergo
          }
        },
        {
          name: 'color',
          path: 'color',
          component: () => import(/* webpackChunkName: "color" */ './components/modules/ColorModule.vue'),
          meta: { requiresGlasses: true },
          props: {
            optionId: ModuleOption.Suncolor
          }
        },
        {
          name: 'color-uni',
          path: 'color/uni',
          component: () => import(/* webpackChunkName: "color" */ './components/modules/ColorSubModule.vue'),
          props: {
            colorSet: ColorSets.Uni,
            optionId: ModuleOption.Suncolor
          }
        },
        {
          name: 'color-degrade',
          path: 'color/degrade',
          component: () => import(/* webpackChunkName: "color" */ './components/modules/ColorSubModule.vue'),
          props: {
            colorSet: ColorSets.Degrade,
            optionId: ModuleOption.Suncolor
          }
        },
        {
          name: 'color-polarized',
          path: 'color/polarized',
          component: () => import(/* webpackChunkName: "color" */ './components/modules/ColorSubModule.vue'),
          props: {
            colorSet: ColorSets.Polarized,
            optionId: ModuleOption.Suncolor
          }
        },
        {
          name: 'color-sun-contrast',
          path: 'color/contrast',
          component: () => import(/* webpackChunkName: "color" */ './components/modules/ColorSubModule.vue'),
          props: {
            colorSet: ColorSets.SunContrast,
            optionId: ModuleOption.Suncolor
          }
        },
        {
          name: 'extra',
          path: 'extra',
          component: () => import(/* webpackChunkName: "glasses" */ './components/modules/ExtraOptionsModule.vue'),
          meta: { requiresGlasses: true }
        }, {
          name: 'thickness',
          path: 'thickness',
          component: () => import(/* webpackChunkName: "glasses" */ './components/modules/ThicknessModule.vue'),
          meta: { requiresGlasses: true },
          props: {
            optionId: ModuleOption.Thickness
          }
        }, {
          name: 'sunthickness',
          path: 'sunthickness',
          component: () => import(/* webpackChunkName: "glasses" */ './components/modules/ThicknessModule.vue'),
          meta: { requiresGlasses: true },
          props: {
            optionId: ModuleOption.Sunthickness
          }
        },
        { path: '*', redirect: '/glasses' }
      ]
    }, {
      path: '/cart',
      component: () => import(/* webpackChunkName: "cart" */ './views/Cart.vue'),
      children: [
        {
          name: 'overview',
          path: '',
          component: () => import(/* webpackChunkName: "cart" */ './components/CartOverview.vue')
        }
      ]
    }
  ]
})
